function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { formatPercent } from "@vestwell-frontend/helpers";
import { useMemo } from "react";
import { PLACEHOLDER } from "../consts";
export var FormatPercent = function(_param) {
    var value = _param.value, options = _object_without_properties(_param, [
        "value"
    ]);
    var formatted = useMemo(function() {
        return value ? formatPercent(value, options) : PLACEHOLDER;
    }, [
        options,
        value
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: formatted
    });
};
FormatPercent.displayName = 'FormatPercent';

//# sourceMappingURL=FormatPercent.js.map